import { render } from "./RegistroAspirante.vue?vue&type=template&id=eeebaf76"
import script from "./RegistroAspirante.vue?vue&type=script&lang=js"
export * from "./RegistroAspirante.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__